<template>
    <validation-provider v-slot="v" :name="name" :rules="rules" slim mode="eager">
        <div class="custom-control custom-checkbox d-flex">
            <input :id="id"
                   :name="name"
                   v-model="valModel"
                   :value="val"
                   type="checkbox"
                   :disabled="disabled"
                   class="custom-control-input">
            <label :for="name" class="custom-control-label" :style="{'margin-top': `${topMargin}px`}" :class="{'has-error': v.errors.length}">
                <slot/>
            </label>
        </div>
        <div v-if="v.errors.length" class="checkbox-invalid-feedback">
            {{ v.errors[0] }}
        </div>
    </validation-provider>
</template>

<script>
export default {
    name: 'AppCheckbox',
    props: {
        id: {
            type: String,
            required: true
        },
        name: String,
        topMargin: Number,
        rules: String,
        disabled: Boolean,
        value: [Boolean, Number],
        val: [Boolean, Number],
    },
    computed: {
        valModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
    .custom-control-label {
        cursor: pointer;

        &.has-error {
            &::before {
                background: lighten(#dc3545, 50%);
                border-color: #dc3545;
            }
        }
    }
    .checkbox-invalid-feedback {
        padding-left: 2rem;
        width: 100%;
        margin-top: 0;
        font-size: 80%;
        color: #dc3545;
    }
</style>
